import React from "react"
import {AppRoutes} from "../../../routes/AppRoutes"
import {NavBar} from "../NavBar"
import styles from "./index.module.scss"

export const SignedInHome = () => {
  return (
    <div className={styles.Container}>
      <NavBar/>
      <div className={styles.Page}>
        <AppRoutes/>
      </div>
    </div>
  )
}
